import Cookies, { CookieAttributes } from 'js-cookie';
import { SiteConfig } from './SiteConfig';
import { SiteConfigStore } from './SiteConfigStore';

const SiteConfigCookieName = '_site_config';

export class SiteConfigCookieStore implements SiteConfigStore {
  constructor(
    private cookieDomain: string | null = null,
    private cookieStore: Cookies.CookiesStatic = Cookies
  ) {}

  private getCookieAttributes(): CookieAttributes | undefined {
    if (this.cookieDomain) {
      return { domain: this.cookieDomain };
    }
    return undefined;
  }

  public writeSiteConfig(siteConfig: SiteConfig): void {
    this.cookieStore.set(
      SiteConfigCookieName,
      siteConfig,
      this.getCookieAttributes()
    );
  }

  public readSiteConfig(): SiteConfig | null {
    try {
      return this.cookieStore.getJSON(SiteConfigCookieName) as SiteConfig;
    } catch (e) {
      return null;
    }
  }
}
